import axios from 'axios';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Does this browser support installable web push at all?
export const pushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

// 'granted' | 'denied' | 'default' | 'unsupported'
export const pushPermission = () => (pushSupported() ? Notification.permission : 'unsupported');

// Register this browser with the server's push service. Assumes permission is already granted.
// Safe to call repeatedly (reuses an existing subscription).
const registerSubscription = async () => {
  const registration = await navigator.serviceWorker.ready;

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const { data } = await axios.get('/api/notifications/vapid-public-key');
    if (!data.publicKey) throw new Error('Server VAPID public key not configured');
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey)
    });
  }

  await axios.post('/api/notifications/subscribe', subscription, {
    headers: { 'x-auth-token': localStorage.getItem('token') }
  });
  return subscription;
};

// Auto-subscribe on app load — ONLY when permission is already granted, so we never trigger a
// permission prompt without a user gesture (iOS installed PWAs reject that). No-op otherwise.
export const subscribeUserToPush = async () => {
  try {
    if (!pushSupported() || Notification.permission !== 'granted') return;
    await registerSubscription();
  } catch (err) {
    console.error('Auto push-subscribe failed:', err);
  }
};

// Gesture-driven enable: request permission, then subscribe. Call from a click/tap handler.
// Returns the resulting permission string so the UI can react.
export const enablePushNotifications = async () => {
  if (!pushSupported()) return 'unsupported';
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    try { await registerSubscription(); }
    catch (err) { console.error('Push subscribe after grant failed:', err); }
  }
  return permission;
};
